import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'bb-table-page-ui',
    templateUrl: './bb-table-page-ui.component.html',
    styles: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class BbTablePageUiComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
